<script setup>
import { useMessagesLoaded, } from '@/assets/js/src/modules/lang/_composables/useMessagesLoaded'
import { useTranslation, } from '@/assets/js/src/util/composables/useTranslation'
import BsBtnIcon from '@/assets/js/src/components/core/BsBtnIcon.vue'

defineProps({
    gridView: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits([ 'toggle', ])
const { messagesLoaded, } = useMessagesLoaded([ 'common', ])
const { t, } = useTranslation()
</script>

<template>
    <bs-btn-icon
        class="mx-0 my-1 my-md-3 my-xl-5"
        :title="messagesLoaded ? t(gridView ? 'async.common.button.list_view' : 'async.common.button.grid_view') : ''"
        @click="emit('toggle')"
    >
        {{ gridView ? 'bs:$vuetify.icons.mdiViewList' : 'bs:$vuetify.icons.mdiApps' }}
    </bs-btn-icon>
</template>

<style lang="scss">
    @use '@/assets/js/src/style/elements/btnAction';

    .bs-app .change-view {
        @include btnAction.btn-action;
    }
</style>
